import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269","key":"svg-0"}],["path",{"d":"M8 20v-5","key":"svg-1"}]]

const IconCellSignal2 = createReactComponent('outline', 'cell-signal-2', 'CellSignal2', __iconNode);

export default IconCellSignal2;